import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

//
import { useTable, useSortBy } from "react-table";

//
import ReactTable from "../../general/ReactTable";

//
import ImageBox from "../../general/ImageBox";

//
import { iconImage } from "../../../redux/features/coins/actions";

function DesktopTopWinners({ items }) {
  // begin::table
  const data = items;

  const columns = React.useMemo(
    () => [
      {
        Header: "Coin",
        accessor: "symbol",
        Cell: (cellProps) => {
          let symbol = cellProps.value;
          let base_name = cellProps.row.original.base_name;
          let target_name = cellProps.row.original.target_name;

          return (
            <div className="d-flex">
              <ImageBox src={iconImage(symbol.split("/")[0])} />
              <div>
                <Link
                  to={`coin-detail/${symbol.split("/")[0]}`}
                  className="fw-bolder text-black"
                >
                  {symbol}
                </Link>
                <small>
                  {base_name} <i className="las la-sync-alt"></i> {target_name}
                </small>
              </div>
            </div>
          );
        },
      },
      {
        Header: "entry price",
        accessor: "entry_price",
        Cell: (cellProps) => {
          let value = cellProps.value;
          let base_name = cellProps.row.original.base_name;
          
          return (
            <small className="text-dark">
         
              {Number(value).toFixed(
                base_name === "Bitcoin" ? 2 : 8
              ).replace(/\.?0+$/, "")}
            </small>
          );
        },
      },
      {
        Header: "action",
        accessor: "action",
        Cell: (cellProps) => {
          let value = cellProps.value;
          return (
            <small
              className={`fw-bolder  ${
                value == "BUY" ? "text-success" : "text-danger"
              }`}
            >
              {value}
            </small>
          );
        },
      },
      {
        Header: "win status",
        accessor: "status",
        Cell: (cellProps) => {
          let value = cellProps.value;
          return <small className="fw-bolder text-black">{value}</small>;
        },
      },
      {
        Header: "max profit",
        accessor: "max_profit_amount",
        Cell: (cellProps) => {
          let value = cellProps.value;
          return <small className="text-black">{value}%</small>;
        },
      },
      {
        Header: "",
        accessor: "base_name",
        Cell: (cellProps) => {
          let value = cellProps.value;
          return <i className="las la-angle-right"></i>;
        },
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data }, useSortBy);
  // end::table
  return (
    <ReactTable
      rows={rows}
      sort
      bodySpace
      prepareRow={prepareRow}
      headerGroups={headerGroups}
      getTableProps={getTableProps}
      getTableBodyProps={getTableBodyProps}
    />
  );
}

DesktopTopWinners.propTypes = {
  items: PropTypes.array.isRequired,
};

export default DesktopTopWinners;
